/**
 * Quem pode entrar em quê.
 *
 * A política de verdade é o menu: o `Sidebar.tsx` sempre escondeu as entradas
 * administrativas de quem não é admin, mas as rotas ficavam abertas — bastava
 * digitar a URL para montar o formulário inteiro e só descobrir o bloqueio
 * quando a primeira chamada voltasse 403. Estas listas são a transcrição
 * daquelas condições, e `MyRoutes.tsx` é onde elas são aplicadas.
 *
 * ⚠️ **Isto é experiência, não segurança.** A maior parte das rotas Go
 * correspondentes está aberta a qualquer autenticado (`routes.go`: questions
 * :198,:201,:203 · subjects :147-149 · testingagencies :154-156 ·
 * selectionprocesses :167-170 · products :173-175 · subscribers :184-186 ·
 * mocktests :190-192,:233-237). Só arquivos, PDFs, shared-texts e templates de
 * revisão têm `requireAdminOrMaster`. Um aluno com `curl` continua passando.
 */

export type Profile =
  | 'administrador'
  | 'master'
  | 'basico'
  | 'competidor'
  | 'free'
  | 'simulado';

/** Cadastro de usuários (`Sidebar.tsx:203`) e Produto (`:256`). */
export const MASTER: Profile[] = ['master'];

/** O bloco de administração inteiro (`Sidebar.tsx:200-201`). */
export const ADMIN: Profile[] = ['administrador', 'master'];

/**
 * Submenu Simulado (`Sidebar.tsx:120-126`).
 *
 * `competidor` fica de fora **de propósito**, espelhando o menu — mesmo ele
 * contando como pagante em `PAID` e existindo ali uma entrada "Competitivo"
 * que ele não alcança. Se um dia isso for corrigido, corrija nos dois lugares.
 */
export const SIMULADO: Profile[] = ['administrador', 'master', 'basico'];

/** Assinatura ativa. Era duplicado em `SubscribedRoute` e `Login.view`. */
export const PAID: Profile[] = ['administrador', 'master', 'basico', 'competidor'];

export function hasProfile(
  profile: string | null | undefined,
  allow: Profile[],
): boolean {
  return !!profile && (allow as string[]).includes(profile);
}

/** Perfis sem plano — a negativa deles é de assinatura, não de cargo. */
export function isUnpaid(profile: string | null | undefined): boolean {
  return !profile || !hasProfile(profile, PAID);
}
